type Card = {
  key: string
  value: string
}

export type HipsProperties = {
  cards: Card[]
}

// 描画側も URL に /properties を付けるため、サービスのベース URL に統一する。
export function normalizeHipsUrl(input: string): string | undefined {
  const value = input.trim().replace(/\/+$/, '')
  if (!/^(https?:)?\/\//i.test(value)) {
    return undefined
  }

  try {
    const parsed = new URL(value, 'https://example.invalid')
    if (
      !['http:', 'https:'].includes(parsed.protocol) ||
      !parsed.hostname ||
      parsed.username ||
      parsed.password ||
      parsed.search ||
      parsed.hash
    ) {
      return undefined
    }
    return value
  }
  catch {
    return undefined
  }
}

export function parseHipsProperties(input: string): HipsProperties {
  const cards: Card[] = []

  for (const line of input.split('\n')) {
    const trimmed = line.trim()
    if (!trimmed || trimmed.startsWith('#')) {
      continue
    }
    const separator = line.indexOf('=')
    if (separator < 0) {
      continue
    }
    const key = line.slice(0, separator).trim()
    const value = line.slice(separator + 1).trim()
    if (key && value) {
      cards.push({ key, value })
    }
  }

  return { cards }
}

// URL 追加・編集とインスペクターで同じ検証を行う。
export async function fetchHipsProperties(baseUrl: string, signal?: AbortSignal): Promise<HipsProperties> {
  const response = await fetch(`${baseUrl}/properties`, { signal })
  if (!response.ok) {
    throw new Error(`HTTP ${response.status}`)
  }

  const properties = parseHipsProperties(await response.text())
  const values = Object.fromEntries(properties.cards.map(({ key, value }) => [key, value]))
  const order = Number(values.hips_order)
  const width = Number(values.hips_tile_width)
  if (
    !Number.isInteger(order) || order < 0 ||
    !Number.isInteger(width) || width <= 0 ||
    !values.hips_tile_format
  ) {
    throw new Error('HiPS properties が不正です (hips_order / hips_tile_width / hips_tile_format)')
  }
  return properties
}
